'use strict';

var React = require("react");

require("./SplashScreen.css");

var nimbusLogo = require("@assets/nimbus_logo_colored.png").default;

function SplashScreen(Props) {
  return React.createElement("div", {
              className: "ss-container"
            }, React.createElement("img", {
                  className: "ss-logo",
                  alt: "logo",
                  src: nimbusLogo
                }));
}

var make = SplashScreen;

exports.nimbusLogo = nimbusLogo;
exports.make = make;
/*  Not a pure module */
